import CountDownTimer from './CountDownTimer';
import { SendEmailForm } from './SendEmailForm';
import { CopyIcon } from '../Auth/Profile/icons/CopyIcon';
import { useAppDispatch } from '../../hooks/hooks';
import { showAlert } from '../../store/alertsReducer';

type Props = {
  coupon: string;
  discount?: string;
  nextSpinAt?: string | null;
};

export const Congratulation = ({ coupon, discount, nextSpinAt }: Props) => {
  const dispatch = useAppDispatch();
  const copyText = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => dispatch(showAlert({ alerts: 'Copied to clipboard', successType: true })));
  };

  return (
    <div className='text-center'>
      <p className='eyebrow eyebrow--bare mb-4 justify-center'>You won</p>
      <h2 className='display-lg'>Congratulations</h2>

      <p className='lede mx-auto mt-3 max-w-[40ch]'>
        You won a <b className='text-ink-900'>{discount}</b> coupon. Use it on your next gift card.
      </p>

      <div className='mx-auto mt-7 flex w-fit items-center gap-2'>
        <span className='voucher-amount rounded-xl border border-dashed border-line-strong bg-canvas px-5 py-3 !text-[26px] !tracking-[0.12em]'>
          {coupon}
        </span>
        <button
          type='button'
          onClick={() => copyText(coupon)}
          aria-label='Copy coupon code'
          className='flex h-11 w-11 items-center justify-center rounded-xl border border-line
            text-ink-500 transition-colors hover:border-ink-900 hover:text-ink-900'
        >
          <CopyIcon />
        </button>
      </div>

      {!!nextSpinAt && (
        <p className='mt-6 text-[14px] text-ink-500'>
          Your next spin is available in{' '}
          <b className='text-ink-900'>
            <CountDownTimer targetDate={nextSpinAt} />
          </b>
        </p>
      )}

      <SendEmailForm coupon={coupon} />
    </div>
  );
};
